import { render } from "./ProductListView.vue?vue&type=template&id=2a99ea62&ts=true"
import script from "./ProductListView.vue?vue&type=script&lang=ts"
export * from "./ProductListView.vue?vue&type=script&lang=ts"

import "./ProductListView.vue?vue&type=style&index=0&id=2a99ea62&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__